import React, { forwardRef } from 'react';
import styled from '@emotion/styled';

interface Props {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

const NoStylesButton = (props: Props, ref: React.Ref<HTMLButtonElement>) => {
  return <Button ref={ref} {...props} />;
};

export default forwardRef(NoStylesButton);

const Button = styled.button`
  background: transparent;
  padding: 0;
  border: none;
  color: inherit;
`;
